import React, { Component } from "react";
import RemotingService from "../../../services/remoting-service/RemotingService";
import AuthService from "../../../services/auth-service/AuthService";
import PackageConsentForm from "../../patient/patientdetail/package/PackageConsentForm";

export default class PublicPackageConsentForm extends Component {

    onClose = () => {
        this.setState({
            language: undefined,
        });
        this.props.close();
    }

    render() {
        let { form } = this.props;

        return (
            <>
                <PackageConsentForm
                    show={true}
                    close={this.onClose}
                    onFormComplete={this.handleConsentFormComplete}
                    form={form} fullScreen={true}
                    language={this.props.language}
                    patientId={this.props.patientId}
                />
            </>
        );
    }

    handleConsentFormComplete = (consentForm) => {
        const patientId = this.props.form.patientId;
        const patientName = this.props.form.patientName;
        const packageId = this.props.form.packageId;
        const code = this.props.consentFormCode;
        const targetUrl = `api/public/consent-form/code/${code}/package-consent-form`;
        const requestBody = {
            ...consentForm,
            patientId,
            patientName,
            packageId,
        };

        RemotingService.postRemoteCall(targetUrl, requestBody,
            () => {
                // Form submission successful
                // Close will be handled by the parent component
            });
    
        this.props.onFormSubmit(consentForm);
    }


}
